import api from "../../../api/api";

export const listPromoCodes = (params) => api.get("/root/promo-codes", { params });

export const getPromoCodeDetail = (id) => api.get(`/root/promo-codes/${id}`);

export const createPromoCode = (data) => api.post("/root/promo-codes", data);

export const updatePromoCode = (id, data) =>
  api.post(`/root/promo-codes/${id}/update`, data);

export const deletePromoCode = (id, data) =>
  api.post(`/root/promo-codes/${id}/delete`, data);

export const listCampaigns = () => api.get("/root/promo-codes/campaigns");

export const getCampaignSettings = (params) =>
  api.get("/root/promo-codes/settings", { params });

export const updateCampaignSettings = (data) =>
  api.post("/root/promo-codes/settings", data);
